module.exports = __webpack_public_path__ + "static/media/io.7a5adee8.png";